import type { Locale } from '$lib/i18n/types';
import { magazineUrlByLocale } from '$lib/services/advertising/magazine';

const legalLinksFR = {
	legalNotice: `${magazineUrlByLocale['fr-FR']}mentions-legales/`,
	termOfUse: `${magazineUrlByLocale['fr-FR']}conditions-generales-dutilisation/`,
	cookies: '',
	credit: `${magazineUrlByLocale['fr-FR']}credits`,
	confidentialityPolicy: `${magazineUrlByLocale['fr-FR']}donnees-personnelles/`,
	contact: `${magazineUrlByLocale['fr-FR']}contact/`,
};
const legalLinksEN = {
	legalNotice: `${magazineUrlByLocale['en-GB']}legal-notice/`,
	termOfUse: `${magazineUrlByLocale['en-GB']}general-terms-and-conditions-of-use/`,
	cookies: '',
	credit: `${magazineUrlByLocale['en-GB']}credits/`,
	confidentialityPolicy: `${magazineUrlByLocale['en-GB']}personal-data/`,
	contact: `${magazineUrlByLocale['en-GB']}contact-us/`,
};
const legalLinksDE = {
	legalNotice: `${magazineUrlByLocale['de-DE']}rechtshinweise/`,
	termOfUse: `${magazineUrlByLocale['de-DE']}allgemeine-nutzungsbedingungen/`,
	cookies: '',
	credit: `${magazineUrlByLocale['de-DE']}copyright/`,
	confidentialityPolicy: `${magazineUrlByLocale['de-DE']}personliche-daten/`,
	contact: `${magazineUrlByLocale['de-DE']}kontaktieren-sie-uns/`,
};
const legalLinksIT = {
	legalNotice: `${magazineUrlByLocale['it-IT']}menzioni-legali/`,
	termOfUse: `${magazineUrlByLocale['it-IT']}condizioni-generali-di-utilizzo/`,
	cookies: '',
	credit: `${magazineUrlByLocale['it-IT']}crediti/`,
	confidentialityPolicy: `${magazineUrlByLocale['it-IT']}dati-personali/`,
	contact: `${magazineUrlByLocale['it-IT']}contattaci/`,
};
const legalLinksES = {
	legalNotice: `${magazineUrlByLocale['es-ES']}aviso-legal/`,
	termOfUse: `${magazineUrlByLocale['es-ES']}condiciones-generales-de-uso/`,
	cookies: '',
	credit: `${magazineUrlByLocale['es-ES']}creditos/`,
	confidentialityPolicy: `${magazineUrlByLocale['es-ES']}datos-personales/`,
	contact: `${magazineUrlByLocale['es-ES']}contacta-con-nosotros/`,
};
const defaultLegalLinks = {
	legalNotice: `${magazineUrlByLocale['en-US']}legal-notice/`,
	termOfUse: `${magazineUrlByLocale['en-US']}general-terms-and-conditions-of-use/`,
	cookies: '',
	credit: `${magazineUrlByLocale['en-US']}credits/`,
	confidentialityPolicy: `${magazineUrlByLocale['en-US']}personal-data/`,
	contact: `${magazineUrlByLocale['en-US']}contact-us/`,
};

export const legalLinksPerLocale: Record<
	Locale,
	{
		legalNotice: string;
		termOfUse: string;
		cookies: string;
		credit: string;
		confidentialityPolicy: string;
		contact: string;
	}
> = {
	'fr-FR': legalLinksFR,
	'fr-BE': legalLinksFR,
	'fr-CH': legalLinksFR,
	'en-GB': legalLinksEN,
	'en-IE': defaultLegalLinks,
	'en-US': legalLinksEN,
	'de-AT': legalLinksDE,
	'de-CH': legalLinksDE,
	'de-DE': legalLinksDE,
	'it-CH': legalLinksIT,
	'it-IT': legalLinksIT,
	'es-ES': legalLinksES,
	'nl-BE': defaultLegalLinks,
	'nl-NL': defaultLegalLinks,
	'pt-PT': defaultLegalLinks,
};
